import React, { useState } from 'react';
import axios from 'axios';
import { CircularProgress } from '@material-ui/core';
import './PDFUpload.css';

function PDFUpload({ bookId, onUploadSuccess, canUpload = false }) {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const API_URL = process.env.REACT_APP_API_URL;

    if (!canUpload) {
        return null;
    }

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === 'application/pdf') {
            setFile(selectedFile);
            setError('');
        } else {
            setFile(null);
            setError('Please select a valid PDF file');
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setError('Please select a file first');
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append('pdf', file);
        formData.append('isAdmin', true);

        try {
            const response = await axios.post(
                `${API_URL}api/books/uploadpdf/${bookId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (response.status === 200) {
                setFile(null);
                if (onUploadSuccess) {
                    onUploadSuccess(response.data.pdfUrl);
                }
            }
        } catch (err) {
            setError(err.response?.data || 'Error uploading PDF');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pdf-upload-container">
            <div className="pdf-upload-content">
                <input
                    type="file"
                    accept=".pdf"
                    onChange={handleFileChange}
                    className="pdf-file-input"
                    id="pdf-upload"
                />
                <label htmlFor="pdf-upload" className="pdf-upload-label">
                    {file ? file.name : 'Choose PDF file'}
                </label>

                <button
                    onClick={handleUpload}
                    disabled={!file || loading}
                    className="upload-button"
                >
                    {loading ? <CircularProgress size={24} /> : 'Upload PDF'}
                </button>

                {error && <div className="upload-error">{error}</div>}
            </div>
        </div>
    );
}

export default PDFUpload; 